import { createSlice } from '@reduxjs/toolkit'
import { get, noop } from 'lodash'

import api from 'common/api'

export const getProfile = () => api.get(`/api/application/cycle/current`)

const appCycleDomain = createSlice({
  name: 'applicationCycle',
  initialState: 0,
  reducers: {
    setAppCycle(_, action) {
      return action.payload
    },
  },
})

export const selectApplicationCycle = (state) => get(state, 'applicationCycle')
export const { setAppCycle } = appCycleDomain.actions

export const fetchCurrentAppCycle = () => (dispatch) =>
  getProfile()
    .then((appCycle) => dispatch(setAppCycle(appCycle)))
    .catch(noop)
export default appCycleDomain.reducer
